import { render } from "./ImportExportServices.vue?vue&type=template&id=1b85bbca&scoped=true"
import script from "./ImportExportServices.vue?vue&type=script&lang=js"
export * from "./ImportExportServices.vue?vue&type=script&lang=js"

import "./ImportExportServices.vue?vue&type=style&index=0&id=1b85bbca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b85bbca"]])

export default __exports__